<script>
	import BoardBase from './BoardBase.svelte';
	import Mission from './Mission.svelte';
	import PlayerAid from './PlayerAid.svelte';
	import SpecialtyMultipliers from './SpecialtyMultipliers.svelte';

	export let board;
	export let side;
	export let p;
	export let isPreview = false;
	let isAdvanced;

	$: isAdvanced = side === 'advanced';

</script>

<BoardBase {p} deck={board.deck} {side} preview={isPreview} special={board.special || false}>
	<svelte:fragment slot="missions">
		{#if board.missions[0]}<Mission {p} preview={isPreview} mission={board.missions[0]} {isAdvanced} />{/if}
		{#if isAdvanced}
			{#if board.missions[1]}<Mission {p} preview={isPreview} mission={board.missions[1]} {isAdvanced} />{/if}
			{#if board.missions[2]}<Mission {p} preview={isPreview} mission={board.missions[2]} {isAdvanced} />{/if}
		{:else}
			<PlayerAid />
		{/if}
	</svelte:fragment>
	<svelte:fragment slot="tracks">
		<SpecialtyMultipliers {p} preview={isPreview} track="research" trackValues={board.research} topOffset={41} {isAdvanced} />
		<SpecialtyMultipliers {p} preview={isPreview} track="influence" trackValues={board.influence} topOffset={60.25} {isAdvanced} />
		<SpecialtyMultipliers {p} preview={isPreview} track="military" trackValues={board.military} topOffset={79.5} {isAdvanced} />
	</svelte:fragment>
</BoardBase>
